import { Controller } from '@hotwired/stimulus';

const SCRIPT_CONTENT_TYPE = /\b(?:java|ecma)script\b/;

export default class extends Controller {
  submit() {
    this.element.requestSubmit();
  }

  track(event) {
    const [xhr] = event.detail;

    if (this.pending && this.pending !== xhr) this.pending.abort();

    this.pending = xhr;
  }

  settle(event) {
    const xhr = event.detail[2];

    this.pending = null;

    if (!xhr || SCRIPT_CONTENT_TYPE.test(xhr.getResponseHeader('Content-Type') || '')) return;

    this.#leave(xhr);
  }

  fail(event) {
    const xhr = event.detail[2];

    this.pending = null;

    if (!xhr || xhr.status === 0) return;

    this.#leave(xhr);
  }

  #leave(xhr) {
    window.location.href = xhr.responseURL || window.location.href;
  }
}
